var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.072,
    height: 15.067,
    viewBox: "0 0 15.072 15.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M2.413,15.067A2.414,2.414,0,0,1,0,12.655V2.411A2.414,2.414,0,0,1,2.412,0H7.352A2.414,2.414,0,0,1,9.763,2.411V3.9a.707.707,0,0,1-1.413,0V2.411a1,1,0,0,0-1-1H2.412a1,1,0,0,0-1,1V12.656a1,1,0,0,0,1,1H7.351a1,1,0,0,0,1-1V10.934a.707.707,0,0,1,.707-.707h0a.707.707,0,0,1,.707.707v1.722a2.414,2.414,0,0,1-2.412,2.412Zm8.932-4.505a.707.707,0,0,1,0-1L12.666,8.24H6.54a.707.707,0,1,1,0-1.413h6.126l-1.31-1.31a.72.72,0,0,1,0-1.02.707.707,0,0,1,.99.01L14.86,7.019h0a.726.726,0,0,1,0,1.027l-2.516,2.515a.707.707,0,0,1-1,0Z",
    transform: "translate(-0.001)",
    fill: "#3b57a9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4b8939ef341bf84052d1a9dcc9be20bd.svg";
export { ForwardRef as ReactComponent };